module.exports = __webpack_public_path__ + "img/home.7e5dfc6c.png";